module.exports = __webpack_public_path__ + "img/chromatography.1924bfc9.svg";